"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableAdd = exports.StyledButtonContainer = exports.StyledTableCell = exports.StyledAddTabContent = exports.StyledTabAddTitle = exports.StyledOptionsContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem, toRemString } = ui_common_components_1.utils;
exports.StyledOptionsContainer = styled_components_1.default.div `
  display: flex;
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  flex-direction: column;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledTabAddTitle = styled_components_1.default.div ``;
exports.StyledAddTabContent = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledTableCell = styled_components_1.default.div `
  ${({ theme, isHighlighted }) => (0, styled_components_1.css) `
    border-radius: ${rem(theme.Border.Radius.Small)};
    border: ${rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
    height: ${rem(theme.Spacing.Size.Large)};
    width: ${rem(theme.Spacing.Size.Large)};
    transition: all ${theme.Transition.Timing.In};
    background: ${isHighlighted
    ? theme.Color.System.Primary
    : theme.Color.Neutrals.Paper};
    box-shadow: ${toRemString([0, 2, 0, 0])} rgba(0, 0, 0, 0.02);
  `}
`;
exports.StyledButtonContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  width: fit-content;
  ${({ theme, variant }) => (0, styled_components_1.css) `
    max-height: ${rem(theme.Spacing.Size.XLarge)};
    max-width: ${variant === 'tooltip'
    ? rem(theme.Spacing.Size.XLarge)
    : 'auto'};
  `}

  & button {
    ${({ theme, variant }) => (0, styled_components_1.css) `
      max-height: ${rem(theme.Spacing.Size.XLarge)};
      max-width: ${variant === 'tooltip'
    ? rem(theme.Spacing.Size.XLarge)
    : 'auto'};
    `}
  }
`;
function TableAdd({ icon, title, onUpdate }) {
    const matrixSize = 5; // Define the size of the matrix
    const matrix = Array.from({ length: matrixSize * matrixSize });
    const initialCellValue = -1;
    const correctionIndicator = 1;
    const [selectedCell, setSelectedCell] = (0, react_1.useState)({
        row: initialCellValue,
        col: initialCellValue,
    });
    const handleMouseEnter = (0, react_1.useCallback)((index) => {
        const row = Math.floor(index / matrixSize);
        const col = index % matrixSize;
        setSelectedCell({ row, col });
    }, []);
    const handleMouseLeave = () => {
        setSelectedCell({ row: initialCellValue, col: initialCellValue });
    };
    return ((0, jsx_runtime_1.jsx)(ui_common_components_1.DropdownNext, { options: [
            {
                type: 'custom',
                value: title,
                children: ((0, jsx_runtime_1.jsxs)(exports.StyledOptionsContainer, { children: [(0, jsx_runtime_1.jsxs)(exports.StyledTabAddTitle, { children: [selectedCell.row + 1, " x ", selectedCell.col + 1, " Table"] }), (0, jsx_runtime_1.jsx)(exports.StyledAddTabContent, { children: matrix.map((_, index) => {
                                const row = Math.floor(index / matrixSize);
                                const col = index % matrixSize;
                                const isHighlighted = row <= selectedCell.row && col <= selectedCell.col;
                                return ((0, jsx_runtime_1.jsx)(exports.StyledTableCell, { onMouseEnter: () => handleMouseEnter(index), onMouseLeave: handleMouseLeave, isHighlighted: isHighlighted, onClick: () => onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
                                        data: {
                                            row: selectedCell.row + correctionIndicator,
                                            col: selectedCell.col + correctionIndicator,
                                        },
                                    }) }, index));
                            }) })] })),
            },
        ], placement: "bottom", trigger: "click", children: (0, jsx_runtime_1.jsx)(exports.StyledButtonContainer, { variant: "title", children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "ghost", icon: icon, label: title, onClick: (event) => event.preventDefault() }) }) }));
}
exports.TableAdd = TableAdd;
//# sourceMappingURL=TableAdd.js.map